import {makeActionCreator} from '~/shared/store/redux-toolbelt';

export const setIsAgeConfirmed = makeActionCreator<'setIsAgeConfirmed', boolean>('setIsAgeConfirmed');
